/**
 * Imperative bridge from the start-page trial card to the trial-onboarding
 * surfaces owned by `useTrialOnboarding` (mounted in App): the card requests
 * an intent, the hook consumes it and opens the matching dialog.
 */
import { create } from 'zustand';

export type TrialPromptIntent = 'trial-dialog' | 'sign-in';

interface TrialPromptStore {
  requested: TrialPromptIntent | null;
  request: (intent: TrialPromptIntent) => void;
  consume: () => void;
}

export const useTrialPromptStore = create<TrialPromptStore>((set) => ({
  requested: null,
  request: (intent) => set({ requested: intent }),
  consume: () => set({ requested: null }),
}));
